import React from 'react'
import * as S from './Form.styles'

interface Props {
  className?: string
  onSubmit: any
  children: React.ReactNode
}

export default ({ onSubmit, children, className }: Props) => (
  <S.Form onSubmit={onSubmit} className={className}>
    {children}
  </S.Form>
)
